<div class="content-header">
    <div class="title">
        <a>
            EMPRESA: {{ organization }}
        </a>
    </div>

    <div class="help" (click)="btnHelp()" *ngIf="iconHelp">
        <fa-icon icon="question-circle"></fa-icon>
    </div>
</div>
